<template>
  <div>
    <DataTable
      api="/admin/purchases"
      :on-row-selected-callback="onPurchaseSelected"
    />
  </div>
</template>

<script>
import DataTable from '@core/components/data-table/DataTable.vue'

export default {
  components: {
    DataTable,
  },
  data() {
    return {
    }
  },
  methods: {
    onPurchaseSelected(row) {
      this.$router.push(`/accounts/${row[0].email}/purchases/${row[0].productId}`)
    },
  },
}
</script>
